module.exports = __webpack_public_path__ + "media/images/classpoints/brands/RH-cfa9af8adacc6a037a6cec7c76d27994.svg";